/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { IotDeviceStateOfUse } from './IotDeviceStateOfUse';
import {
    instanceOfIotDeviceStateOfUse,
    IotDeviceStateOfUseFromJSON,
    IotDeviceStateOfUseFromJSONTyped,
    IotDeviceStateOfUseToJSON,
} from './IotDeviceStateOfUse';

/**
 * @type QaEquipmentCatalogDtoIotDeviceStateOfUse
 * 
 * @export
 */
export type QaEquipmentCatalogDtoIotDeviceStateOfUse = IotDeviceStateOfUse;


export function QaEquipmentCatalogDtoIotDeviceStateOfUseFromJSON(json: any): QaEquipmentCatalogDtoIotDeviceStateOfUse {
    return QaEquipmentCatalogDtoIotDeviceStateOfUseFromJSONTyped(json, false);
}

export function QaEquipmentCatalogDtoIotDeviceStateOfUseFromJSONTyped(json: any, ignoreDiscriminator: boolean): QaEquipmentCatalogDtoIotDeviceStateOfUse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...IotDeviceStateOfUseFromJSONTyped(json, true) };
    return  IotDeviceStateOfUseFromJSONTyped(json, true);
}

export function QaEquipmentCatalogDtoIotDeviceStateOfUseToJSON(value?: QaEquipmentCatalogDtoIotDeviceStateOfUse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfIotDeviceStateOfUse(value)) {
        return IotDeviceStateOfUseToJSON(value as IotDeviceStateOfUse);
    }

    return {};
}

/**
 * Check if a given object implements the QaEquipmentCatalogDtoIotDeviceStateOfUse interface.
 */
export function instanceOfQaEquipmentCatalogDtoIotDeviceStateOfUse(value: any): value is QaEquipmentCatalogDtoIotDeviceStateOfUse {
    if (instanceOfIotDeviceStateOfUse(value)) return true;
    return false;
}

